import { useTranslation } from 'react-i18next'

import { Field } from '@/components/ui/Field'
import { Input } from '@/components/ui/Input'
import { isBlankOrCreditDays } from '@/features/quotes/quoteDraft'

/* «Дней отсрочки» — the credit term's day count (S-12, C-2; locked visual
 * decision 7).
 *
 * One question revealed by another (the GOV.UK conditional reveal): it appears
 * only while the terms are «Кредит», directly under the terms select, set in by
 * a 2px NEUTRAL rule so it reads as part of that answer rather than as a field
 * of its own. The hint states the server's range; the server's refusal —
 * `required` on a quote changed to credit, `invalid` outside 1–365 — lands
 * under it in place of the hint, and a malformed figure is said while it is
 * typed.
 *
 * Shared by the deal-terms card and the header sheet, the two surfaces that ask
 * the terms, so the two cannot word or bound it differently. The host decides
 * WHEN to render it (`isCreditTerms`); this decides nothing about the terms. */
export function CreditDaysField({
  value,
  onChange,
  serverError,
  disabled,
}: {
  value: string
  onChange: (next: string) => void
  /** The server's refusal of the field, already worded (`creditDaysError`). */
  serverError?: string
  disabled?: boolean
}) {
  const { t } = useTranslation()
  const malformed = !isBlankOrCreditDays(value)

  return (
    <div className="border-border-default ml-1 border-l-2 pl-4">
      <Field
        label={t('quotes.form.creditDays')}
        hint={t('quotes.form.creditDaysHint')}
        error={malformed ? t('quotes.form.creditDaysHint') : serverError}
      >
        {(props) => (
          <Input
            inputMode="numeric"
            className="asa-num"
            value={value}
            disabled={disabled}
            onChange={(event) => onChange(event.target.value)}
            {...props}
          />
        )}
      </Field>
    </div>
  )
}
